import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {};
  },
  props: {
    items: {
      default: function _default() {
        return [];
      },
      type: Array
    }
  },
  wathch: {},
  methods: {
    showTable: function showTable() {
      if ('roleList' == this.items[this.items.length - 1].name) {
        return false;
      }
      if ('auditEmpList' == this.items[this.items.length - 1].name) {
        return false;
      }
      return true;
    },
    jumpToNewPage: function jumpToNewPage(path) {
      this.$router.push("/main/" + path + "Add");
    },
    myOrderAuditList: function myOrderAuditList() {
      this.$router.push("/main/myOrderAuditList");
    },
    addNewExperts: function addNewExperts() {
      this.$emit("showDialog");
    },
    addNewAuditEmp: function addNewAuditEmp() {
      this.$emit('showDialog');
    },
    buildBid: function buildBid() {
      this.$router.push("/main/buildBidding");
    }
  },
  computed: {}
};